// shared/context/TutorialProvider.js
import React, { useState, useCallback } from "react";
import { TutorialContext } from "./tutorial-context";
import TutorialModal from "../components/tutorialModal/TutorialModal";

export const TutorialProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tutorialData, setTutorialData] = useState({
    type: null, // 'video' ou 'text'
    content: null, // URL do vimeo ou texto
    title: "",
  });

  const showTutorial = useCallback((data) => {
    setTutorialData({
      type: data.type,
      content: data.content,
      title: data.title || "Ajuda",
    });
    setIsOpen(true);
  }, []);

  const closeTutorial = useCallback(() => {
    setIsOpen(false);
    // Delay para limpar os dados após a animação de fechamento
    setTimeout(() => {
      setTutorialData({
        type: null,
        content: null,
        title: "",
      });
    }, 300);
  }, []);

  return (
    <TutorialContext.Provider
      value={{
        showTutorial,
        closeTutorial,
        isOpen,
      }}
    >
      {children}
      {isOpen && (
        <TutorialModal
          isOpen={isOpen}
          onClose={closeTutorial}
          type={tutorialData.type}
          content={tutorialData.content}
          title={tutorialData.title}
        />
      )}
    </TutorialContext.Provider>
  );
};
